// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"79":"56a3b8c7","655":"67d36f21","727":"7c059eb0","853":"ebbc9dd2"}[chunkId] + ".chunk.css";
};